import React, {
  useState,
} from "react";

import {
  FiMenu,
} from "react-icons/fi";

import SuperAdminNavbar from
  "./navbar/SuperAdminNavbar";

import "./Platform.css";

import "./navbar/SuperAdminNavbar.css";


/*
|--------------------------------------------------------------------------
| PLATFORM LAYOUT
|--------------------------------------------------------------------------
|
| Sidebar/navigation has been moved to:
|
| ./navbar/SuperAdminNavbar.jsx
|
|--------------------------------------------------------------------------
*/

const PlatformLayout = ({
  children,

  title = "",

  description = "",

  headerActions = null,
}) => {

  /*
  |--------------------------------------------------------------------------
  | NAVBAR STATE
  |--------------------------------------------------------------------------
  */

  const [
    sidebarPinned,
    setSidebarPinned,
  ] =
    useState(
      true
    );


  const [
    mobileSidebarOpen,
    setMobileSidebarOpen,
  ] =
    useState(
      false
    );


  /*
  |--------------------------------------------------------------------------
  | LAYOUT CLASS
  |--------------------------------------------------------------------------
  */

  const layoutClassName =
    [
      "platform-layout",

      sidebarPinned
        ?
        "super-admin-navbar-pinned"
        :
        "",
    ]
      .filter(
        Boolean
      )
      .join(
        " "
      );


  /*
  |--------------------------------------------------------------------------
  | UI
  |--------------------------------------------------------------------------
  */

  return (
    <div
      className={
        layoutClassName
      }
    >

      <SuperAdminNavbar
        pinnedOpen={
          sidebarPinned
        }
        onPinnedOpenChange={
          setSidebarPinned
        }
        mobileOpen={
          mobileSidebarOpen
        }
        onMobileOpenChange={
          setMobileSidebarOpen
        }
      />


      <main
        className="platform-layout-main"
      >

        <div
          className="platform-mobile-toolbar"
        >
          <button
            type="button"
            className="platform-mobile-menu-button"
            onClick={
              () =>
                setMobileSidebarOpen(
                  true
                )
            }
            title="Open navigation"
            aria-label="Open navigation"
          >
            <FiMenu />
          </button>


          <strong>
            COMKWIK Platform
          </strong>
        </div>


        {
          title ||
          description ||
          headerActions
            ?
            (
              <header
                className="platform-layout-header"
              >

                <div
                  className="platform-layout-header-content"
                >

                  {
                    title
                      ?
                      <h1>
                        {
                          title
                        }
                      </h1>
                      :
                      null
                  }


                  {
                    description
                      ?
                      <p>
                        {
                          description
                        }
                      </p>
                      :
                      null
                  }

                </div>


                {
                  headerActions
                    ?
                    (
                      <div
                        className="platform-layout-header-actions"
                      >
                        {
                          headerActions
                        }
                      </div>
                    )
                    :
                    null
                }

              </header>
            )
            :
            null
        }


        <div
          className="platform-layout-content"
        >
          {
            children
          }
        </div>

      </main>

    </div>
  );
};


export default PlatformLayout;
